"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConflictingLabelFilter = exports.LabelFilterItem = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
const uuid_1 = require("uuid");
const data_1 = require("@grafana/data");
const e2e_selectors_1 = require("@grafana/e2e-selectors");
const ui_1 = require("@grafana/ui");
const InputGroup_1 = require("../../QueryEditor/InputGroup");
const AccessoryButton_1 = require("../../QueryEditor/AccessoryButton");
const CONFLICTING_LABEL_FILTER_ERROR_MESSAGE = 'You have conflicting label filters';
function LabelFilterItem({ item, items, defaultOp, onChange, onDelete, onGetLabelNames, onGetLabelValues, invalidLabel, invalidValue, multiValueSeparator = "|", }) {
    var _a;
    const [state, setState] = (0, react_1.useState)({});
    // there's a bug in react-select where the menu doesn't recalculate its position when the options are loaded asynchronously
    // see https://github.com/grafana/grafana/issues/63558
    // instead, we explicitly control the menu visibility and prevent showing it until the options have fully loaded
    const [labelNamesMenuOpen, setLabelNamesMenuOpen] = (0, react_1.useState)(false);
    const [labelValuesMenuOpen, setLabelValuesMenuOpen] = (0, react_1.useState)(false);
    const isMultiSelect = (operator = item.op) => {
        var _a;
        return (_a = operators.find((op) => op.label === operator)) === null || _a === void 0 ? void 0 : _a.isMultiValue;
    };
    const getSelectOptionsFromString = (item) => {
        if (item) {
            if (item.indexOf(multiValueSeparator) > 0) {
                return item.split(multiValueSeparator);
            }
            return [item];
        }
        return [];
    };
    const getOptions = () => {
        const labelValues = state.labelValues ? [...state.labelValues] : [];
        const selectedOptions = getSelectOptionsFromString(item === null || item === void 0 ? void 0 : item.value).map(data_1.toOption);
        // Remove possible duplicated values
        return (0, lodash_1.uniqBy)([...selectedOptions, ...labelValues], 'value');
    };
    const isConflicting = isConflictingLabelFilter(item, items);
    const { current: id } = (0, react_1.useRef)((0, uuid_1.v4)());
    return (react_1.default.createElement("div", { "data-testid": "visual-query-builder-dimensions-filter-item" },
        react_1.default.createElement(ui_1.InlineField, { error: CONFLICTING_LABEL_FILTER_ERROR_MESSAGE, invalid: isConflicting ? true : undefined },
            react_1.default.createElement(InputGroup_1.InputGroup, null,
                react_1.default.createElement(ui_1.Select, { placeholder: "Select label", "data-testid": e2e_selectors_1.selectors.components.QueryBuilder.labelSelect, inputId: `visual-query-builder-dimensions-filter-item-key-${id}`, width: "auto", value: item.label ? (0, data_1.toOption)(item.label) : null, allowCustomValue: true, onOpenMenu: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        setState({ isLoadingLabelNames: true });
                        const labelNames = yield onGetLabelNames(item);
                        setLabelNamesMenuOpen(true);
                        setState({ labelNames, isLoadingLabelNames: undefined });
                    }), onCloseMenu: () => {
                        setLabelNamesMenuOpen(false);
                    }, isOpen: labelNamesMenuOpen, isLoading: state.isLoadingLabelNames, options: state.labelNames, onChange: (change) => {
                        var _a;
                        if (change.value) {
                            onChange(Object.assign(Object.assign({}, item), { op: (_a = item.op) !== null && _a !== void 0 ? _a : defaultOp, label: change.value }));
                        }
                    }, invalid: isConflicting || invalidLabel }),
                react_1.default.createElement(ui_1.Select, { "data-testid": e2e_selectors_1.selectors.components.QueryBuilder.matchOperatorSelect, value: (0, data_1.toOption)((_a = item.op) !== null && _a !== void 0 ? _a : defaultOp), options: operators, width: "auto", onChange: (change) => {
                        if (change.value) {
                            onChange(Object.assign(Object.assign({}, item), { op: change.value, value: isMultiSelect(change.value) ? item.value : getSelectOptionsFromString(item === null || item === void 0 ? void 0 : item.value)[0] }));
                        }
                    }, invalid: isConflicting }),
                react_1.default.createElement(ui_1.Select, { placeholder: "Select value", "data-testid": e2e_selectors_1.selectors.components.QueryBuilder.valueSelect, inputId: `visual-query-builder-dimensions-filter-item-value-${id}`, width: "auto", value: isMultiSelect()
                        ? getSelectOptionsFromString(item === null || item === void 0 ? void 0 : item.value).map(data_1.toOption)
                        : getSelectOptionsFromString(item === null || item === void 0 ? void 0 : item.value).map(data_1.toOption)[0], allowCustomValue: true, onOpenMenu: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        setState({ isLoadingLabelValues: true });
                        const labelValues = yield onGetLabelValues(item);
                        setState(Object.assign(Object.assign({}, state), { labelValues, isLoadingLabelValues: undefined }));
                        setLabelValuesMenuOpen(true);
                    }), onCloseMenu: () => {
                        setLabelValuesMenuOpen(false);
                    }, isOpen: labelValuesMenuOpen, isMulti: isMultiSelect(), isLoading: state.isLoadingLabelValues, options: getOptions(), onChange: (change) => {
                        var _a, _b;
                        if (change.value) {
                            onChange(Object.assign(Object.assign({}, item), { value: change.value, op: (_a = item.op) !== null && _a !== void 0 ? _a : defaultOp }));
                        }
                        else {
                            // otherwise, we're dealing with a multi-value select which is array of options
                            const changes = change
                                .map((change) => {
                                if (change.value) {
                                    return change.value;
                                }
                                else {
                                    return undefined;
                                }
                            })
                                .filter((val) => val !== undefined)
                                .join(multiValueSeparator);
                            onChange(Object.assign(Object.assign({}, item), { value: changes, op: (_b = item.op) !== null && _b !== void 0 ? _b : defaultOp }));
                        }
                    }, invalid: isConflicting || invalidValue }),
                react_1.default.createElement(AccessoryButton_1.AccessoryButton, { "aria-label": "remove", icon: "times", variant: "secondary", onClick: onDelete })))));
}
exports.LabelFilterItem = LabelFilterItem;
const operators = [
    { label: '=', value: '=', description: 'Equals', isMultiValue: false },
    { label: '!=', value: '!=', description: 'Does not equal', isMultiValue: false },
    { label: '=~', value: '=~', description: 'Matches regex', isMultiValue: true },
    { label: '!~', value: '!~', description: 'Does not match regex', isMultiValue: true },
];
function isConflictingLabelFilter(newLabel, labels) {
    if (!newLabel.label || !newLabel.op || !newLabel.value) {
        return false;
    }
    if (labels.length < 2) {
        return false;
    }
    const operationIsNegative = newLabel.op.toString().startsWith('!');
    const candidates = labels.filter((label) => label.label === newLabel.label && label.value === newLabel.value && label.op !== newLabel.op);
    const conflict = candidates.some((candidate) => {
        var _a, _b;
        if (operationIsNegative && ((_a = candidate === null || candidate === void 0 ? void 0 : candidate.op) === null || _a === void 0 ? void 0 : _a.toString().startsWith('!')) === false) {
            return true;
        }
        if (operationIsNegative === false && ((_b = candidate === null || candidate === void 0 ? void 0 : candidate.op) === null || _b === void 0 ? void 0 : _b.toString().startsWith('!'))) {
            return true;
        }
        return false;
    });
    return conflict;
}
exports.isConflictingLabelFilter = isConflictingLabelFilter;
//# sourceMappingURL=LabelFilterItem.js.map